<div class="line-guage-chart-section">
  <svg height="0" width="0">
    <defs>
      <filter id="f1" x="0" y="0" width="150%" height="150%">
        <feOffset result="offOut" in="SourceGraphic" dx="8" dy="8" />
        <feColorMatrix result="matrixOut" in="offOut" type="matrix" values="0.2 0 0 0 0 0 0.2 0 0 0 0 0 0.2 0 0 0 0 0 0.2 0" />
        <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="7" />
        <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
      </filter>
    </defs>
  </svg>
</div>
